module.exports = __webpack_public_path__ + "static/media/15.M-Cure 3-c.d4df5503.jpg";